import React from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { NoDataPage } from '../../resources/components/NoDataPage'

const CaptableManagementQuickActions = ({ title }: { title: string }) => {
    const { formatMessage } = useIntl()
    return (
        <Card className='w-100 p-4 bg-white'>
            <div >
                <p className='text-muted'>{formatMessage({ id: title })}</p>
                <div className='d-flex align-items-center justify-content-center' style={{ height: '300px' }}>
                    <NoDataPage />
                </div>
            </div>
        </Card>
    )
}

export default CaptableManagementQuickActions